import React from "react";

const ITEMS = [
  "Segurança",
  "Altura",
  "NR-35",
  "Confinado",
  "NR-33",
  "Resgate técnico",
  "Alpinismo industrial",
  "Linhas de vida",
  "ISO 45001",
  "Prontidão 24/7",
];

export const Marquee = () => {
  return (
    <div
      data-testid="marquee-strip"
      className="bg-[#05121F] border-y border-white/10 overflow-hidden"
    >
      <div className="flex animate-marquee-slow py-8 sm:py-12 whitespace-nowrap will-change-transform">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            className="font-condensed uppercase font-bold tracking-[-0.01em] px-6 sm:px-10 inline-flex items-center text-white/85 text-[3rem] sm:text-[4.5rem] lg:text-[6rem] leading-none"
          >
            {t}
            <span className="ml-6 sm:ml-10 inline-block w-3 h-3 sm:w-4 sm:h-4 bg-[#2FA36B] rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
